"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./../../../libs/utils");

var _label = _interopRequireDefault(require("../label"));

var _RenderIf = _interopRequireDefault(require("../../RenderIf"));

var _relativeElement = _interopRequireDefault(require("../../Structural/relativeElement"));

var _container = _interopRequireDefault(require("../styled/container"));

var _iconContainer = _interopRequireDefault(require("../styled/iconContainer"));

var _input = _interopRequireDefault(require("./styled/input"));

var _helpText = _interopRequireDefault(require("../styled/helpText"));

var _errorText = _interopRequireDefault(require("../styled/errorText"));

var InputBase =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(InputBase, _Component);

  function InputBase(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, InputBase);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(InputBase).call(this, props));
    _this.inputId = (0, _utils.uniqueId)('input');
    _this.inlineTextLabelId = (0, _utils.uniqueId)('inline-text-label');
    _this.errorMessageId = (0, _utils.uniqueId)('error-message');
    _this.inputRef = _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(InputBase, [{
    key: "getInlineTextLabelId",
    value: function getInlineTextLabelId() {
      var bottomHelpText = this.props.bottomHelpText;

      if (bottomHelpText) {
        return this.inlineTextLabelId;
      }

      return undefined;
    }
  }, {
    key: "getErrorMessageId",
    value: function getErrorMessageId() {
      var error = this.props.error;

      if (error) {
        return this.errorMessageId;
      }

      return undefined;
    }
    /**
     * Sets focus on the element.
     * @public
     */

  }, {
    key: "focus",
    value: function focus() {
      this.inputRef.current.focus();
    }
    /**
     * Sets click on the element.
     * @public
     */

  }, {
    key: "click",
    value: function click() {
      this.inputRef.current.click();
    }
    /**
     * Sets blur on the element.
     * @public
     */

  }, {
    key: "blur",
    value: function blur() {
      this.inputRef.current.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          value = _this$props.value,
          label = _this$props.label,
          error = _this$props.error,
          placeholder = _this$props.placeholder,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          tabIndex = _this$props.tabIndex,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          onClick = _this$props.onClick,
          onKeyDown = _this$props.onKeyDown,
          type = _this$props.type,
          maxLength = _this$props.maxLength,
          minLength = _this$props.minLength,
          pattern = _this$props.pattern,
          icon = _this$props.icon,
          bottomHelpText = _this$props.bottomHelpText,
          required = _this$props.required,
          id = _this$props.id,
          autoComplete = _this$props.autoComplete,
          name = _this$props.name,
          hideLabel = _this$props.hideLabel,
          isBare = _this$props.isBare,
          isCentered = _this$props.isCentered,
          iconPosition = _this$props.iconPosition;
      return _react["default"].createElement(_container["default"], {
        id: id,
        className: className,
        style: style
      }, _react["default"].createElement(_label["default"], {
        label: label,
        hideLabel: hideLabel,
        required: required,
        inputId: this.inputId,
        readOnly: readOnly,
        id: this.getInlineTextLabelId()
      }), _react["default"].createElement(_relativeElement["default"], null, _react["default"].createElement(_RenderIf["default"], {
        isTrue: !!icon
      }, _react["default"].createElement(_iconContainer["default"], {
        iconPosition: iconPosition,
        readOnly: readOnly,
        error: error
      }, icon)), _react["default"].createElement(_input["default"], {
        id: this.inputId,
        name: name,
        type: type,
        value: value,
        placeholder: placeholder,
        onChange: onChange,
        tabIndex: tabIndex,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick,
        onKeyDown: onKeyDown,
        disabled: disabled,
        readOnly: readOnly,
        required: required,
        maxLength: maxLength,
        minLength: minLength,
        pattern: pattern,
        autoComplete: autoComplete,
        "aria-labelledby": this.getInlineTextLabelId(),
        "aria-describedby": this.getErrorMessageId(),
        ref: this.inputRef,
        isBare: isBare,
        isCentered: isCentered,
        iconPosition: iconPosition,
        icon: icon,
        error: error
      })), _react["default"].createElement(_RenderIf["default"], {
        isTrue: !!bottomHelpText
      }, _react["default"].createElement(_helpText["default"], {
        alignSelf: "center"
      }, bottomHelpText)), _react["default"].createElement(_RenderIf["default"], {
        isTrue: !!error
      }, _react["default"].createElement(_errorText["default"], {
        alignSelf: "center",
        id: this.getErrorMessageId()
      }, error)));
    }
  }]);
  return InputBase;
}(_react.Component);

exports["default"] = InputBase;
InputBase.propTypes = {
  value: _propTypes["default"].string,
  name: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['text', 'password', 'datetime', 'datetime-local', 'date', 'month', 'time', 'week', 'number', 'email', 'url', 'search', 'tel', 'color']),
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  placeholder: _propTypes["default"].string,
  icon: _propTypes["default"].node,
  iconPosition: _propTypes["default"].oneOf(['left', 'right']),
  maxLength: _propTypes["default"].number,
  minLength: _propTypes["default"].number,
  bottomHelpText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  required: _propTypes["default"].bool,
  pattern: _propTypes["default"].string,
  isCentered: _propTypes["default"].bool,
  isBare: _propTypes["default"].bool,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  id: _propTypes["default"].string,
  autoComplete: _propTypes["default"].string,
  hideLabel: _propTypes["default"].bool
};
InputBase.defaultProps = {
  value: undefined,
  name: undefined,
  type: 'text',
  label: undefined,
  placeholder: undefined,
  icon: undefined,
  iconPosition: 'left',
  maxLength: undefined,
  minLength: undefined,
  bottomHelpText: null,
  required: false,
  pattern: undefined,
  isCentered: false,
  isBare: false,
  error: null,
  disabled: false,
  readOnly: false,
  onChange: function onChange() {},
  tabIndex: undefined,
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onKeyDown: function onKeyDown() {},
  className: undefined,
  style: undefined,
  id: undefined,
  autoComplete: 'on',
  hideLabel: false
};